const ignoreFields = ['Category'];

const categoryIdToSortMap = {
  // comments are category paths
  1972: 'ExtraField1', // LOOKS PRONTOS
  340: 'ExtraField2', // MAIS PROCURADOS
  2001: 'ExtraField5', // DIA DAS MÃES
  2006: 'ExtraField8', // SEMI JOIAS>ÚLTIMAS UNIDADES
  1935: 'ExtraField11', // SEMI JOIAS>PROMOÇÃO
};

const priceLevel = window.Convermax.cartpricelevel ? btoa(window.Convermax.cartpricelevel) : '';

function getSearchRequestDefaults(pageType) {
  const { pathname } = window.location;
  const categoryId = pageType === 'category' ? +pathname.replace(/.+_c_(\d+).html/, '$1') : null;
  return {
    pageSize: 24,
    // eslint-disable-next-line camelcase
    extra: { plv_id: priceLevel },
    sort: categoryIdToSortMap[categoryId],
  };
}

export default {
  platform: 'shift4shop',
  searchPageUrl: '/Search_ep_44-1.html',
  getSearchRequestDefaults,
  // eslint-disable-next-line camelcase
  autocomplete: { requestDefaults: { extra: { plv_id: priceLevel } } },
  facets: {
    selectFacet: {
      fields: ['COR DO BANHO', 'CATEGORIA', 'Price', 'TAMANHO DO ANEL', 'COR DA PEDRA'],
      showHitCount: false,
      useNativeDropdown: false,
    },
  },
  Widgets: [
    {
      name: 'SearchPage',
      location: '#extrapage, section.category-products',
      visibleIf: { selector: '#cm_results, section#category' },
      template: 'MainContent',
    },
    {
      name: 'SearchBox',
      location: '#searchBox',
      template: 'SearchBox',
    },
    {
      name: 'SearchBoxDialogButton',
      location: { replace: 'a[data-target="#searchModal"]', class: 'pull-right' },
      template: 'searchBox/dialogButtonMobile',
    },
    {
      name: 'SearchHeader',
      sortEntries: {
        'relevance': 'Mais procurados',
        'Price': 'Preço: menor > maior',
        'Price:desc': 'Preço: maior > menor',
        'Name': 'Nome',
      },
    },
    {
      name: 'AttributesPanel',
      type: 'FacetPanel',
      disableCollapse: true,
    },
    {
      name: 'SearchResult',
      updateCallback: bindAddToCartClickHandler,
    },
    {
      name: 'FacetDialog',
      template: 'FacetDialog',
      ignoreFields,
    },
    {
      name: 'SearchBoxDialog',
      template: 'SearchBoxDialog',
    },
  ],
};

function bindAddToCartClickHandler() {
  $('.product-item[data-ajaxcart="1"] .add-to-cart')
    .off('click')
    .click(async (e) => {
      e.preventDefault();
      const $this = e.currentTarget;
      $($this).blur();
      const productDiv = $($this).parents('.product-item');

      if ($(productDiv).hasClass('ajaxcart-loading')) {
        return;
      }

      $(productDiv).addClass('ajaxcart-loading');

      const catalogId = $(productDiv).data('catalogid');
      const categoryId = $(productDiv).data('categoryid');

      await window.Convermax.trackAddToCart(catalogId);

      const product = window.get_product(catalogId, categoryId);

      const stock = parseInt(product.Stock);

      if (stock <= 0) {
        window.location.href = product.ProductLink;
        return;
      }

      let hasOptions = false;
      if (product.OptionSetList) {
        const productOptions = JSON.parse(product.OptionSetList);
        if (productOptions.length > 0) {
          hasOptions = true;
        }
      }

      if (window.isQuickviewEnabled() && (hasOptions || product.IsOptionRequiredForCategory)) {
        window.quickview(`/product.asp?lt_c=1&itemid=${catalogId}&qv=1`);
        $(productDiv).removeClass('ajaxcart-loading');
      } else if (!window.isQuickviewEnabled() && (hasOptions || product.IsOptionRequiredForCategory)) {
        if (product.ProductLink.indexOf('https://') >= 0 || product.ProductLink.indexOf('http://') >= 0) {
          window.location.href = product.ProductLink;
        } else {
          window.location.href = `/${product.ProductLink}`;
        }
      } else {
        window.add_to_cart(product.CatalogID, product.SKU, 0, product.Price, 1, [], false, productDiv);
      }
    });
}

// override global check_and_add function, which is called on the product page
/* eslint-disable camelcase */
if (typeof window !== 'undefined') {
  const check_and_add_orig = window.check_and_add;
  window.check_and_add = async function () {
    const { localItemId: productId } = window.Convermax.templates.config.productConfig;
    if (productId) {
      await window.Convermax.trackAddToCart(productId);
    }
    check_and_add_orig();
  };
}
/* eslint-enable camelcase */
